import ConditionalFormat from "../api/ConditionalFormat";

const conditionalFormats = {};


export const reloadConditionalFormats = async () => {
  for (const existingName of Object.keys(conditionalFormats)) {
    delete conditionalFormats[existingName];
  }
  for (const conditionalFormat of await ConditionalFormat.getList({})) {
    conditionalFormats[conditionalFormat.name] = conditionalFormat;
  }
};


reloadConditionalFormats();


export default conditionalFormats;
